<template>
  
    <div class="fullScreen">
       <div  style="top: 20px;right: 10px;opacity: .6;" class="helpIcon" @click="showHelp"></div>
    <div class="floorPlan"  :style="'opacity:1;transform:scale('+planScale+') translate('+planLeft+'px,'+planTop+'px);'">
      <div class=planBtns> 
        <div @click="goTo('exhibition')" class="planBtn">Preview Exhibition</div>
        <div @click="transTo('game','Back to the Lighthouse')" class="planBtn">Open Exhibition</div>
        <div v-if="false" @click="transTo('exhibition','The Exhibition Opens')" class="planBtn">Open Exhibition</div>
      </div>  
    </div>
    <div v-if="debug" class="debug">   
     </div>
      <div >
         <drop class="drop" @drop="handleDropOUT" :style="'width:100%;height:80%;top:0px;left:0px;opacity:0;'">
           </drop>
          <drop ref="leftWall" class="drop" @drop="handleDropLeft" :style="'width:'+(636*planScale)+'px;height:'+(220*planScale)+'px;top:0'+(130+planTop)*planScale+'px;left:'+(100+planLeft)*planScale+'px;'">
             <div v-if="debug && isTester" style="color:#fff3;position:absolute;">WIDTH {{leftWidth}} {{planScale}}</div>
            <div  @click="selectItem(lw)" v-for="(lw,i) in leftItems" :key="'lw'+i" class="wallItem" :style="'width:'+((lw.width)/(636-5*leftItems.length)*100)+'%;margin:5px;'">
                 <drag :class="lw.class +' imageIcon'" :style="'background-image:'+thumbImage(lw)+'; width:100%; height:100%;'" :transfer-data="{ wall:leftItems,index:i }" ></drag>
   
            </div>
          </drop>
          <drop ref="frontWall" class="drop" @drop="handleDropFront" :style="'width:'+(456*planScale)+'px;height:'+(220*planScale)+'px;top:0'+(130+planTop)*planScale+'px;left:'+(804+planLeft)*planScale+'px;'">
            <div  v-if="debug && isTester" style="color:#fff3;position:absolute;">WIDTH {{frontWidth}} {{456*planScale}}</div>
         
            <div @click="selectItem(fw)" v-for="(fw,fi) in frontItems" :key="'fw'+fi" class="wallItem" :style="'width:'+((fw.width)/(450-5*frontItems.length)*100)+'%;margin:5px;'">
                <drag :class="fw.class +' imageIcon'" :style="'background-image:'+thumbImage(fw)+';width:100%; height:100%;'" :transfer-data="{ wall:frontItems,index:fi }" ></drag>
      </div>
          </drop>
           <drop ref="rearWall" class="drop" @drop="handleDropRear" :style="'width:'+(456*planScale)+'px;height:'+(220*planScale)+'px;top:0'+(430+planTop)*planScale+'px;left:'+(100+planLeft)*planScale+'px;'">
               <div  v-if="debug && isTester" style="color:#fff3;position:absolute;">WIDTH {{rearWidth}} {{456*planScale}}</div>
            <div @click="selectItem(bw)" v-for="(bw,fi) in rearItems" :key="'bw'+fi" class="wallItem" :style="'width:'+((bw.width)/(430-5*rearItems.length)*100)+'%;margin:5px;'">
                 <drag :class="bw.class +' imageIcon'" :style="'background-image:'+thumbImage(bw)+'; width:100%; height:100%;'" :transfer-data="{ wall:rearItems,index:fi }" >{{bw.width}}</drag>
      
                </div>
          </drop>
          <drop ref="rightWall" class="drop" @drop="handleDropRight" :style="'width:'+(636*planScale)+'px;height:'+(220*planScale)+'px;top:0'+(430+planTop)*planScale+'px;left:'+(620+planLeft)*planScale+'px;'">
             <div  v-if="debug && isTester" style="color:#fff3;position:absolute;">WIDTH {{rightWidth}}</div>
            <div @click="selectItem(rw)" v-for="(rw,fi) in rightItems" :key="'rw'+fi" class="wallItem" :style="'width:'+((rw.width)/(636-5*rightItems.length)*100)+'%;margin:5px;'">
                <drag :class="rw.class +' imageIcon'" :style="'background-image:'+thumbImage(rw)+'; width:100%; height:100%;'" :transfer-data="{ wall:rightItems,index:fi }" ></drag>
            </div>
          </drop>
          <div ref="floor" class="drop" @drop="handleDropRight" :style="'width:'+(636*planScale)+'px;height:'+(450*planScale)+'px;top:0'+(130+planTop)*planScale+'px;left:'+(1314+planLeft)*planScale+'px;'">
            <div style="height:50%">
              <div v-if="activeWreck" class="holoWreck" :style="'background-image:'+holoImage+';'"></div>
            <div v-for="(lw,fi) in leftItems" :key="'flw'+fi" class="floorItem" :style="'width:'+((lw.width)/(636)*100)+'%; margin-left:10px;'">
                 <drag :class="'dragX floor-'+lw.class" :transfer-data="{ wall:leftItems,index:fi }"  :style="'width:100%; height:'+(lw.depth*planScale)+'px; left: 0px;'"></drag>
                </div>
            </div>
            <div style="height:50%;">
              <div v-for="(rw,fi) in rightItems" :key="'frw'+fi" class="floorItem" :style="'width:'+((rw.width)/(636)*100)+'%;margin-left:10px;'">
                  <drag :class="'dragX floorL-'+rw.class" :transfer-data="{ wall:rightItems,index:fi }"  :style="'width:100%; height:'+(rw.depth*planScale)+'px;left: 0px;'"></drag>
              </div>
            </div>
          </div>
          <div  ref="floor2" class="drop" @drop="handleDropRight" :style="'width:'+(636*planScale)+'px;height:'+(450*planScale)+'px;top:0'+(130+planTop)*planScale+'px;left:'+(1314+planLeft)*planScale+'px;'">
            <div style="display:inline-block;float:left;height:100%;width:50%;">
              <div class="floorItem" :style="'width:100%;height:22%'"></div>
            <div v-for="(bw,fi) in reverseRear" :key="'fbw'+fi" class="floorItem" :style="'width:100%;height:'+((bw.width)/(430)*100)+'%; margin-top:5px;top:10px;'">
                <drag :class="'dragX floorB-'+bw.class" :transfer-data="{ wall:rearItems,index:fi }"  :style="'width:'+(bw.depth*planScale)+'px;height:100%;'"></drag>
            </div>
            </div>
            <div style="display:inline-block;height:100%;width:50%;">
              <div  v-for="(fw,fi) in frontItems" :key="'ffw'+fi" class="floorItem" :style="'width:100%;height:'+((fw.width)/(420)*100)+'%;margin-top:5px;top:10px;'">
                  <drag :class="'dragX floorF-'+fw.class" :transfer-data="{ wall:frontItems,index:fi }"  :style="'width:'+(fw.depth*planScale)+'px;height:100%;'"></drag>
              </div>
            </div>
          </div>
          
          <drop class="foundItems"  @drop="handleDropOUT" :style="'width:'+(1250*planScale)+'px;height:'+(360*planScale)+'px;top:'+(680+planTop)*planScale+'px;left:'+(110+planLeft)*planScale+'px;'">
                <div class="collectedHeading">Collected Items</div>
                <!-- :image="require('../assets/images/exhibit/'+'bomber/video_TH-t'+'.png')"
                -->
                <div v-for="(f,fi) in foundItems" :key="'f'+fi" :class="'foundItem'" style="width:15%;" @click="selectItem(f)" >
                <drag  @drop="handleDropOUT"  :transfer-data="f"   
                  :class="'imageIcon'" :style="'background-image:'+thumbImage(f)+';'">
                    </drag>
                    <div class="iconText">{{f.shortName}}</div>
                </div>
            </drop>
            <drop v-if="selectedItem" class="itemDetails" :style="'width:'+(650*planScale)+'px;height:'+(360*planScale)+'px;top:'+(640+planTop)*planScale+'px;left:'+(1315+planLeft)*planScale+'px;'">
                  
                   <div v-if="selectedItem.type=='photo' && photos">
                     <div class="collectedHeading" style="position: relative;z-index: 2;">Photo Card   <span style="float:right">use card <p-check @change="showCard" name="acCheck" color="#ff0000" value="custom" v-model="useCard"></p-check></span>
                  </div>
                      <img class="objPreview" style="position: absolute;top:0px;opacity:1" :src="photos[photoIndex]"/>
                      
                     <div v-if="photos.length>0" @click="nextPhoto" class="basicBtn" style="position:absolute;width:100%;bottom:5px;left: 0px;right: 100px;margin: auto;;background-color:#0007;font-weight:600;">Image {{(photoIndex+1)}} of {{photos.length}}</div>
                     <div v-else class="basicBtn" style="position:absolute;width:100%;bottom:5px;left: 0px;right: 100px;margin: auto;;background-color:#0007;font-weight:600;">No Photos Taken</div>
                   
                  </div>
                  <div v-else>
                    <div class="collectedHeading">{{selectedItem.name}} Exhibition Card   <span style="float:right">use card <p-check @change="showCard" name="acCheck" color="#ff0000" value="custom" v-model="useCard"></p-check></span>
                 
                    <div class="objPreview"  :style="'background-image:'+previewImage+';'"></div>
                    <div v-if="useCard" ref="cardText" class="cardBox" @blur="onEdit" contenteditable>{{selectedItem.card}}</div>
                  </div>
                   </div>
              </drop>
             
     </div>
    
      </div>
 
</template>

<script>

import Help from '@/mixins/help'
import screen from "@/mixins/screen"
import { Drag, Drop } from 'vue-drag-drop';

export default {
  name: "Ship",
   components: {
    Drag,Drop
  },
  mixins:[screen, Help],
  data() {
    return {
      photoIndex:0,
      selectedItem:null,
      picFrame: {name:"Frame",type:"picFrame",class:"wallPic",width:60,height:80,depth:10},
      plinth: {name:"Plinth",type:"plinth",class:"wallPlinth",width:50,height:80,depth:50},
      floor: {name:"Floor",type:"floor",class:"wallPlinth",width:50,height:80,depth:50},
      screen: {name:"Screen", type:"screen",class:"wallScreen",width:180,height:100,depth:14},
      photo: {name:"Gallery", type:"photo",class:"wallPic",width:70,height:70,depth:10,photoIndex:1},
      foundItems:[],
      
      useCard:false,
      //draggable2: 'Drag Me OUT',
      doScan:false,
      mapVis:false,
      imageWidth:2000,
      imageHeight:1125,
      mapState:"planMapFS",
      
      leftItems:[],
      frontItems:[],
      rearItems:[],
      reverseRear:[],
      rightItems:[],
      helps:[	
        {id:"H601_dragItems",showOnce:false,shown:false,help:{}},
				{id:"H602_addCard",showOnce:false,shown:false,help:{}},
			]
     //
     
    };
  },
  mounted(){
    
    if(!this.wrecks){
         this.$store.dispatch("loadWrecks")
       	return
    }else{
      console.log("WRECK",this.wreck)
      if(this.wreck && !this.exhibitionLoaded){
        this.$store.dispatch('getExhibition')    
      }else{
        this.$nextTick(() => {
          this.startScene()
        })
      }
    } 
  },
  computed:{
    isTester(){
      return this.$store.getters.getIsTester
    },
    rearWidth(){
      var width=0
      for(var i in this.rearItems){
        width+=this.cardWidth(this.rearItems[i]) 
      }
      return width
    },
    leftWidth(){
      var width=0
      for(var i in this.leftItems){
        width+=this.cardWidth(this.leftItems[i]) 
      }
      return width
    },
    rightWidth(){
      var width=0
      for(var i in this.rightItems){
        width+=this.cardWidth(this.rightItems[i]) 
      }
      return width
    },
    frontWidth(){
      var width=0
      for(var i in this.frontItems){
        width+=this.cardWidth(this.frontItems[i]) 
      }
      return width
    },
    exhibitionLoaded(){
				return this.$store.getters.getExhibitionLoaded
			},
    wrecks(){
     			return this.$store.getters.getWrecks
      },
      wreck(){
     			return this.$store.getters.getWreck
      },
      activeWreck(){
				if(this.gameStatus){
					return this.gameStatus.activeWreck
				}
			},
			gameStatus(){
				return this.$store.getters.getGameStatus
			},
    activeWreckStatus(){	
					return this.$store.getters.getActiveWreck
		},
    debug(){
				return this.$store.getters.getDebug
      },
      
     exhibitionLayout(){
				return this.$store.getters.getExhibitLayout
			},
      scannedItems(){
				return this.$store.getters.getScannedItems
			},
			collectedItems(){
				return this.$store.getters.getCollectedItems
			},
			photos(){
        let photos=this.$store.getters.getPhotos
        if(photos && photos.length>0){
          return this.$store.getters.getPhotos
        }
        
				return  []
      },
    holoImage(){
      if(this.activeWreck){
       let image=require("../assets/images/exhibit/"+this.activeWreck+"/wreck_TH.png")
           console.log(image)
           return 'url('+image+')'
      }
    },
    previewImage(){
      if(this.selectedItem){
        if(this.selectedItem.thumbNail && this.selectedItem.thumbNail!="-------"){
           console.log("../assets/images/exhibit/"+this.selectedItem.thumbNail+".png",this.selectedItem)
           let image=require("../assets/images/exhibit/"+this.selectedItem.thumbNail+".png")
           console.log(image)
           return 'url('+image+')'
        }
        console.log("NO Image")
        
      }else{
        console.log("NO PREVIEW")
        return 'none'
      }
    },
    planLeft(){
       return this.containLeft(this.imageWidth,this.imageHeight)
    },
    planTop(){
       return this.containTop(this.imageWidth,this.imageHeight)
    },
    planScale(){
      return this.containScale(this.imageWidth,this.imageHeight)
    },
    
  },
  methods:{
    thumbImage(item){
           if(item.type=="photo"){
             return 'url('+this.photos[item.photoIndex]+')'
           }
           let image=require("../assets/images/exhibit/"+item.thumbNail+".png")
           return 'url('+image+')'
       
        
    },
    cardWidth(card){
      console.log("CARD",card)
      if(card.width){
        return card.width
      }
      else if(card.type=="picFrame"){
          return (parseFloat(card.scaleX,10)*22)+100
        }else if(card.type=="screen"){
          return 210
        }else{
          return 100
        }
    },
    getInitObjs(){
       if(this.activeWreck=="bomber"){
        this.foundItems=[
          {shortName:"Blueprint",name:"Bomber Blueprint",path:"beaufort/bomberBP.png",thumbNail:"beaufort/bomberBP_TH",scaleX:1.54,type:"image",card:"Enter Details here"},
          {shortName:"Poster",name:"Poster",path:"beaufort/poster.jpg",thumbNail:"beaufort/poster_TH",scaleX:.666,type:"image",card:"Enter Details here"},
          {shortName:"Map",name:"Map",path:"beaufort/map.jpg",thumbNail:"beaufort/map_TH",scaleX:1.333,type:"image",card:"Enter Details here"},
          {shortName:"Journal",name:"Journal",type:"object",path:"beaufort/Book",thumbNail:"beaufort/journal2_TH",scale:2,card:"Enter Details here",rotX:0,rotZ:0,solid:true},
           ]
      }else if(this.activeWreck=="bermagui"){
         this.foundItems=[
            {shortName:"Map",name:"Map",path:"bermagui/map.jpg",thumbNail:"beaufort/map_TH",scaleX:1.333,type:"image",card:"Enter Details here"},
        ]
      }else if(this.activeWreck=="enterprise"){
         this.foundItems=[
            {shortName:"Map",name:"Map",path:"enterprise/map.jpg",thumbNail:"beaufort/map_TH",scaleX:1.333,type:"image",card:"Enter Details here"},
        ]
      }else if(this.activeWreck=="pandemonium"){
         this.foundItems=[
            {shortName:"Map",name:"Map",path:"pandemonium/map.jpg",thumbNail:"beaufort/map_TH",scaleX:1.333,type:"image",card:"Enter Details here"},
        ]
      }else if(this.activeWreck=="verdoemd"){
         this.foundItems=[
            {shortName:"Map",name:"Map",path:"verdoemd/map.jpg",thumbNail:"beaufort/map_TH",scaleX:1.333,type:"image",card:"Enter Details here"},
        ]
      }else if(this.activeWreck=="sub"){
         this.foundItems=[
            {shortName:"Map",name:"Map",path:"sub/map.jpg",thumbNail:"beaufort/map_TH",scaleX:1.333,type:"image",card:"Enter Details here"},
        ]
      }else {
        this.foundItems=[
          
           
        ]
      }
      this.foundItems.push({shortName:"Video",name:"Video",type:"video",thumbNail:this.activeWreck+"/video_TH",scaleX:1.66})
      if(this.photos.length>0){
      this.foundItems.push({shortName:"Gallery",name:"Gallery",type:"photo",thumbNail:this.activeWreck+"/video_TH",scaleX:1.66,photoIndex:1})
      }
  },
   startScene(){
     this.getInitObjs()
      this.$store.commit("setSettingsClass","settingsIcon exhibitPlan")
      let item
      for(var ci in this.collectedItems){
        this.foundItems.push(this.collectedItems[ci])
      }
        
        
      for(var si in this.scannedItems){
        let isFound=false
        for(var oi in this.foundItems){
          if(this.foundItems[oi].name==this.scannedItems[si].name){
            isFound=true
          }
        }
        if(!isFound && this.scannedItems[si].type!="None" && this.scannedItems[si].type!="none"){
          this.foundItems.push(this.scannedItems[si])
        }
         
      }
     
      if( this.exhibitionLayout){
          console.log("EX",this.exhibitionLayout)
          this.leftItems=this.exhibitionLayout.leftItems || []
          this.frontItems=this.exhibitionLayout.frontItems || []
          this.rightItems=this.exhibitionLayout.rightItems || []
          this.rearItems=this.exhibitionLayout.rearItems || []
      }
   },
    nextPhoto(){
      this.photoIndex=(this.photoIndex+1)%this.photos.length
      this.selectedItem.photoIndex=this.photoIndex+0
     
    },
    onEdit(evt){
             var src = evt.target.innerText
            
             if(this.selectedItem){
               this.selectedItem.card=src

             }
         },
    showCard(val){
      this.selectedItem.useCard=this.useCard
     
    },
    selectItem(item){
      console.log("SELECT")
      if( this.$refs.cardText){
         this.$refs.cardText.innerText=item.card
      }
     
      this.selectedItem=item
      console.log("---selectItem",item,!isNaN(this.selectedItem.photoIndex))
      if(!isNaN(this.selectedItem.photoIndex)){
        this.photoIndex=this.selectedItem.photoIndex+0
      }else{
         this.photoIndex=0
      }
      console.log("selectItem done")
    },
    updateData(){
      
      console.log("updateData")
      this.$store.commit("setExhibitLayout",
      { leftItems:this.leftItems,
        frontItems:this.frontItems,
        rearItems:this.rearItems,
        rightItems:this.rightItems,
        open:this.exhibitionLayout.open || false
        })
        console.log(this.$store.getters.getExhibitLayout)
        this.$store.dispatch('saveExhibition')
    },
    
   
    handleDropLeft(data, event) {
      console.log("Left DATA",data,this.cardWidth(data),this.leftWidth)
       
       if(this.cardWidth(data)+this.leftWidth>530){
         this.$store.dispatch("showBasicHelp","Not enough room. Remove some items or try another.")
         
       }else{
         this.applyType(data)
         this.addToWall(this.leftItems,this.$refs.leftWall.$el,data,event)
       }
      
    },
    handleDropFront(data, event) {
     
      if(this.cardWidth(data)+this.frontWidth>330){
        this.$store.dispatch("showBasicHelp","Not enough room. Remove some items or try another.")
      
       }else{
        console.log("FRONT DATA",data)
        
        this.applyType(data)
        
        this.addToWall(this.frontItems,this.$refs.frontWall.$el,data,event)
       }
      
    },
    handleDropRear(data, event) {
      if(this.cardWidth(data)+this.rearWidth>220){
        this.$store.dispatch("showBasicHelp","That wall is full. Remove some items or try another.")
      
       }else{
       this.applyType(data)
       let flip=true
      this.addToWall(this.rearItems,this.$refs.rearWall.$el,data,event,flip)
       }
    },
    handleDropRight(data, event) {
      if(this.cardWidth(data)+this.rightWidth>530){
         this.$store.dispatch("showBasicHelp","That wall is full. Remove some items or try another.")
      
       }else{
        this.applyType(data)
        this.addToWall(this.rightItems,this.$refs.rightWall.$el,data,event)
       }
    },
    applyType(obj){
      console.log("APPLY",obj)
      if(obj.data){
        //obj.
      }
      if(!obj.type){
       // obj=obj.wall[obj.index]
      }
      console.log("APPLY TYPE",obj)
      var objType

      switch(obj.type){
        case "object":
          objType=this.plinth
        break;
        case "floor":
          objType=this.floor
        break;
        case "image":
          objType=this.picFrame
        break;
        case "video":
          objType=this.screen
        break;
         case "photo":
          objType=this.photo
        break;
        default:
          return
        break
      }
      
        obj.class=objType.class
        obj.type=objType.type
        obj.width=objType.width
        obj.height=objType.height
        obj.depth=objType.depth
        
        
    },
    addToWall(items,element,data,event,flip){
      
      //selectItem
      let old=null
     
      if(!data.type){
        old={wall:data.wall,index:data.index}
        data=data.wall[data.index]
      }
       let newItem=Object.assign({}, data)
      console.log("ADD to WALL DATA",data,data.wall)
      if(data.name=="Gallery" && this.photos.length<=1){
        this.$store.dispatch("showBasicHelp","You didn't take photos of this wreck")
        return
      }
      let found=false
       for(var i=0 ;i< items.length && !found;i++){
          if(event.screenX<element.offsetWidth/(items.length+1)*(i+1)+element.offsetLeft){
          found=true
            if(flip){
              items.splice(i,0,newItem)
               //items.splice(Math.max(0,i-1),0,data)
            }else{
               items.splice(i,0,newItem)
            }
             
         }
       }
       
        console.log("ITEMS",items)
       if(!found){
         if(flip){
                items.push(newItem)
                //items.unshift(data)
            }else{
                items.push(newItem)
            }
        
       }
       //this.selectItem(newItem)
       if(old){
         old.wall.splice(old.index,1)
       }
       
       this.updateData()
      
      
    },
    handleDropOUT(data, event) {
       console.log("handleDropOUT",data)
       if(data.wall){
          data.wall.splice(data.index,1)
           this.updateData()
       }
      
      //this.leftItems.pop()
    },
    goTo(page,text){
        this.$store.commit("setExhibitMode","preview")
        this.$router.push({ path: page})
      },

    transTo(page,text){
      
        this.$store.commit("setExhibitMode","Launced")
      
        let tText=text || "Meanwhile"
        this.$store.dispatch('startTransition',{text:tText,to:page})
      },
  },
  watch:{
    exhibitionLoaded(val){
				 if(val){
					 console.log("EXHIBIT LAYOUT",this.exhibitionLayout,this.activeWreck)
					this.startScene()
				 }else{
           alert("NO EXHIBITION")
         }
			},
      activeWreck(val){
       this.getInitObjs()
      },
    	 wrecks(val){
          console.log("============ Wrecks",val)
          if(this.activeWreck){
            this.$store.commit('setExhibitionLoaded',false)
           this.$store.commit('setWreckByName',this.activeWreck)
           this.$store.dispatch('getExhibition')
          }
       },
       selectedItem(val){
         console.log("selectedItem",val)
         this.useCard=val.useCard || false
       },
    rearItems(val){
     
      this.reverseRear=[]
      for(var i in val){
        this.reverseRear.unshift(val[i])
      }
    }
  },
  beforeDestroy(){
     this.updateData()
  }
};
</script>

<style>
	.fullScreen{
		width:100%;
		height:100%;
    position:relative;
    background-color: #003;
    overflow:hidden;
    
  }
  
  
  .planBtns{
   width: 500px;
    height: 72px;
    position: absolute;
    bottom: 15px;
    right: 68px;
   
  }
  
  .planBtn{
    display: inline-block;
    text-align: center;
    margin: 13px 20px;
    width: 210px;
    height: 50px;
    color: #ffffff00;
    cursor: pointer;
    pointer-events: auto;
   
  }
  .planBtn:hover{
     background-color: #1d1d8459;
  }
  
  
  .floorPlan{
    transform-origin: top left;
    position:relative;
    width:2000px;
    height:1125px;
    background-image:url("../assets/images/exhibit/layout3.png");
    background-size:contain;
    perspective: 2000px;
     perspective-origin: 50%;  
    
  }
  .holoWreck{
   width: 60%;
    margin: 12% 21%;
    height: 58%;
    position: absolute;
    /* background-color: #fff5; */
    background-size: contain;
  }
  .dragX,.drop {
  font-family: sans-serif;
  display: inline-block;
  border-radius: 2px;

  position: absolute;
  text-align: center;
  vertical-align: top;
}

.dragX {
  cursor:grab;
  color: #fff;
  cursor: move;
  width:200px;
  height:200px;
  background: #ffffff55;
 
}
.drop {
  left:100px;
}
.itemDrop{
  width:100%;
  height:100%;
  background-color: orange;
}
.itemDrop.full{
  background-color: green;
}
  
  .floorPlinth{
    height:10%;
    top:0px;
    left:0px;
    right:0px;
    margin:auto; 
  }
.wallPic{
  
  top:0px;
  bottom:20px;
  left:0px;
  right:0px;
  margin:auto;
}
.wallPhoto{
  top:0px;
  bottom:20px;
  left:0px;
  right:0px;
  margin:auto;
}
.wallPlinth{
  position: relative;
  bottom: -30px;
  left:0px;
  right:0px;
  margin:auto;
}
.wallScreen{
  top:0px;
  bottom:20px;
  left:0px;
  right:0px;
  margin:auto;
  width:100px;
}
.wallItem{
    height:100%;
    width:20%;
    display: inline-block;
    position:relative;
  }
  .floorItem{
    height:100%;
    width:20%;
    padding:0px;
    margin:0px;
    display: inline-block;
    position:relative;
    
  }
 .floor-wallPic{ 
   top:0px;
 }
 .floorL-wallPic{ 
   bottom:0px;
 }
 .floor-wallPhoto{ 
   top:0px;
 }
 .floor-wallScreen{ 
   left:0px;
   right:0px;
   margin:auto;
   top:0px;
 }
 .floorL-wallScreen{ 
   left:0px;
   right:0px;
   margin:auto;
   bottom:0px;
 }
 .floorL-wallPhoto{ 
   bottom:0px;
 }
 .floor-wallPlinth{ 
   top:8px;
 }
 .floorL-wallPlinth{ 
   bottom:8px;
 }
 .floorB-wallPlinth{ 
   top:0px;
   left:8px;
   right:auto;
   bottom:0px;
   margin:auto;
 }
 .floorB-wallPic{ 
   top:0px;
   left:0px;
   right:auto;
   bottom:0px;
   margin:auto;
 }
 .floorB-wallPhoto{ 
   top:0px;
   left:0px;
   right:auto;
   bottom:0px;
   margin:auto;
 }
 .floorB-wallScreen{ 
   top:0px;
   left:0px;
   right:auto;
   bottom:0px;
   margin:auto;
 }
 .floorF-wallPic{ 
   top:0px;
   left:auto;
   right:0px;
   bottom:0px;
   margin:auto;
 }
 .floorF-wallPhoto{ 
   top:0px;
   left:auto;
   right:0px;
   bottom:0px;
   margin:auto;
 }
 .floorF-wallPlinth{ 
   top:0px;
   left:auto;
   right:8px;
   bottom:0px;
   margin:auto;
 }
 .floorF-wallScreen{ 
   top:0px;
   left:auto;
   right:0px;
   bottom:0px;
   margin:auto;
 }
.foundItems{
  pointer-events: auto;
  position:absolute;
  bottom:100px;
  left:20px;
  width:700px;
  height:400px;
 
 
}
.foundItem{
  position: relative;
  float:left;
  text-align:left;
  width:120px;
  color:#ffffff77;
  margin:2px;
  display:block;
  height:70px;
  
}
.collectedHeading{
  text-align:left;
  color:#ffffff77;
}
.imageIcon{
    cursor:pointer;
    pointer-events:auto;
    max-width: 100%;
    width: 100%;
    height: 80px;
    background-size:contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity:0.5;
    filter: grayscale(100%); /*brightness(200%);*/
}
.iconText{
  user-select: none;
  pointer-events: none;
  color:#ffffffcc;
  width:100%;
  position:absolute;
  text-align: center;
  top:20px;
}
.foundIcon{
  display: inline-block;
  left:-10px;
  top:5px;
  background-color:#ffffff99;
  position: relative;
  width:20px;
  height:20px;
  
  background-color:#ffffff55;
}
.foundIcon.image{
  height:27px;
}
.foundIcon.object{
  border-radius:50%;
}
.foundIcon.floor{
  background-color:#ffffff22;
  border-radius:50%;
}
.foundIcon.plinth{
  background-color:#ffffff22;
  border-radius:50%;
}
.foundIcon.picFrame{
  height:27px;
  background-color:#ffffff22;
}

.foundIcon.video{
  width:40px;
}
.foundIcon.screen{
  background-color:#ffffff22;
  width:40px;
}
.foundIcon.photo{
  height:20 px;
 
}
  

.itemDetails{
  position: absolute;
   
   color:#ffffff77;
  
}
.cardBox{
  border:#ffffff77 solid 1px;
  background-color:#000033a6;
  padding:5px;
  width:70%;
  height:80%;
  text-align: left;
  margin:auto;
  margin-top:2%;
  position:relative;
}
.objPreview{
    position:absolute;
    left:0px;
    opacity:0.4;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

.itemKey{
    position: absolute;
     text-align: left;
     font-size:16px;
    bottom: 20px;
    color: #ffffff77;
}
.keyItem{
  display: inline-block;
    width: 160px;
   
}
.container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
}

.Zbox {
  border: 3px solid #666;
  background-color: #ddd;
  border-radius: .5em;
  padding: 10px;
  cursor: move;
}
</style>